import { createContext, useContext } from 'react'
import { useSuspenseQuery } from '@tanstack/react-query'

import API from '@shared/services/src/API'
import { settingsDeserialized } from '@shared/services/src/Settings.mocks'
import { QK } from '@shared/utils'

/**
 * Provide a context for the apps infrastructure settings.
 */
export default function SettingsProvider({ children }) {
  const { data: settings } = useSuspenseQuery({
    queryKey: QK.platform.settings.list,
    queryFn: () => API.platform.settings.list(),
    select,
  })

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>
}

export function SettingsMockedProvider({ children }) {
  return <SettingsContext.Provider value={select(settingsDeserialized)}>{children}</SettingsContext.Provider>
}

export const SettingsContext = createContext(undefined)

export const useSettings = () => useContext(SettingsContext)

/**
 * Return a value for the given setting
 *
 * @example:
 * const someSetting = useSetting(Setting.PhoneNumbersForSms)
 *
 * @param key - The setting key
 * @param select - Map fn
 * @returns {*} - The setting value
 */
export const useSetting = (key, select) => {
  const settings = useSettings()
  return select ? select(settings[key]) : settings[key]
}

export const Setting = {
  PhoneNumbersForSms: 'phone_numbers_for_sms',
  CashPayCBOs: 'cash_pay_cbo_ids',
  ReachLACBOId: 'reach_la_cbo_id',
}

const select = (data) => {
  return Object.entries(data).reduce((acc, [key, value]) => {
    acc[key] = value
    return acc
  }, {})
}
